import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import {AwsRum, AwsRumConfig} from "aws-rum-web";
import {environment} from "./environments/environment";


try {
  const config: AwsRumConfig = {
    sessionSampleRate: 1 ,
    endpoint: "https://dataplane.rum.us-east-1.amazonaws.com" ,
    telemetries: ["performance","errors","http"] ,
    allowCookies: true ,
    enableXRay: false ,
    signing: false
  };

  const APPLICATION_ID: string = environment.rumApplicationId;
  const APPLICATION_VERSION: string = '1.0.0';
  const APPLICATION_REGION: string = 'us-east-1';

  new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config
  );
} catch(error) {
  console.error('Failed to initialize AWS RUM:', error);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
